import {
    EmailAuthProvider,
    getAuth,
    reauthenticateWithCredential,
} from "firebase/auth";

const reauthenticate = (providedPassword: string) => {
    const auth = getAuth();
    const user = auth.currentUser;

    // Shouldn't be invoked when the user is not authenticated.
    const credential = EmailAuthProvider.credential(
        user!.email!,
        providedPassword,
    );
    return reauthenticateWithCredential(user!, credential);
};

export default reauthenticate;
